// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"94cc0912","386":"d81bfc6c"}[chunkId] + ".chunk.js";
};